export enum GitProvider {
  Matillion = 'matillion',
  Github = 'github'
}
